(function () {
  if (window.__hsFitGuide) return;
  window.__hsFitGuide = true;

  var CM = 2.54;
  var KG = 0.4536;
  var KEY = 'hsFitAnswers';
  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var range = function (text) {
    var n = String(text).match(/\d+(?:\.\d+)?/g);
    return n ? [Number(n[0]), Number(n[n.length - 1])] : null;
  };
  var inches = function (cm) {
    return Math.round((cm / CM) * 2) / 2;
  };
  // Re-render after the click finished: dialog.js closes the popup when the clicked node is no longer inside it
  var later = function (fn) {
    requestAnimationFrame(fn);
  };

  // Rough body measurements (cm) from height and weight, calibrated on EU women's sizing
  var BODY = {
    bust: { label: 'Bust', slope: 2.4, base: 34, height: 0.25 },
    waist: { label: 'Tummy', slope: 2.3, base: 19, height: 0.25 },
    hips: { label: 'Hips', slope: 2.1, base: 49, height: 0.3 }
  };
  var SHAPE_CM = 5;
  var SHAPES = ['Narrower', 'Average', 'Fuller'];
  var FITS = {
    firm: { title: 'Firm hold', text: 'Snug and sculpting, maximum shaping', shift: -0.2 },
    regular: { title: 'Just right', text: 'True to size, the way it is designed', shift: 0.1 },
    comfort: { title: 'Easy comfort', text: 'Softer hold for all-day wear', shift: 0.45 }
  };

  function bodyPart(name) {
    var n = name.toLowerCase();
    if (/bust|chest/.test(n)) return 'bust';
    if (/waist|tummy/.test(n)) return 'waist';
    if (/hip/.test(n)) return 'hips';
    return null;
  }

  function loadAnswers() {
    var a = { h: 0, w: 0, sys: 'metric', shape: { bust: 0, waist: 0, hips: 0 }, fit: 'regular', done: false };
    try {
      var saved = JSON.parse(localStorage.getItem(KEY));
      if (saved && saved.h > 0 && saved.w > 0) {
        a.h = Number(saved.h);
        a.w = Number(saved.w);
        a.sys = saved.sys === 'imperial' ? 'imperial' : 'metric';
        ['bust', 'waist', 'hips'].forEach(function (k) {
          var v = saved.shape && Number(saved.shape[k]);
          a.shape[k] = v === -1 || v === 1 ? v : 0;
        });
        a.fit = FITS[saved.fit] ? saved.fit : 'regular';
        a.done = !!saved.done;
      }
    } catch (e) {}
    return a;
  }

  function saveAnswers(a) {
    try {
      localStorage.setItem(KEY, JSON.stringify(a));
    } catch (e) {}
  }

  var validBody = function (a) {
    return a.h >= 130 && a.h <= 215 && a.w >= 35 && a.w <= 220;
  };

  function setup(root) {
    if (root.__hsFit) {
      // a variant change re-renders the block and empties what this script drew
      if (!root.querySelector('[data-fit-finder]').firstChild) root.__hsFit();
      return;
    }
    var node = root.querySelector('[data-fit-data]');
    if (!node) return;
    var data;
    try {
      data = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }

    var cols = data.cols.map(function (c) {
      return { name: c.replace(/\*\s*$/, '').trim(), measured: /\*\s*$/.test(c) };
    });
    var state = { unit: 'cm', hit: -1, mode: 'tape', step: 1, a: loadAnswers() };
    var el = function (name) {
      return root.querySelector('[data-fit-' + name + ']');
    };
    var measured = cols
      .map(function (c, i) {
        return { name: c.name, cell: i + 1 };
      })
      .filter(function (c) {
        return cols[c.cell - 1].measured;
      });
    var parts = measured
      .map(function (m) {
        return { name: m.name, cell: m.cell, key: bodyPart(m.name) };
      })
      .filter(function (m) {
        return m.key;
      });
    var canQuiz = data.kind !== 'bra' && parts.length > 0;

    function sizeInput(size) {
      var scope = root.closest('.shopify-section') || document;
      var want = String(size).toLowerCase();
      return Array.prototype.find.call(scope.querySelectorAll('variant-picker input[type="radio"]'), function (input) {
        return String(input.value).toLowerCase() === want;
      });
    }

    function show(tab) {
      root.querySelectorAll('[data-fit-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b.dataset.fitTab === tab));
      });
      root.querySelectorAll('[data-fit-panel]').forEach(function (p) {
        p.hidden = p.dataset.fitPanel !== tab;
      });
    }

    function renderTable() {
      var head = '<tr><th>Size</th>' + cols.map(function (c) {
        return '<th>' + esc(c.name) + (c.measured ? ' (' + state.unit + ')' : '') + '</th>';
      }).join('') + '</tr>';
      var body = data.rows.map(function (row, r) {
        return '<tr class="' + (r === state.hit ? 'is-hit' : '') + '">' + row.map(function (cell, i) {
          var text = cell;
          if (i > 0 && cols[i - 1] && cols[i - 1].measured && state.unit === 'in') {
            var rg = range(cell);
            if (rg) text = inches(rg[0]) + ' - ' + inches(rg[1]);
          }
          return '<td class="' + (data.kind === 'bra' && i > 0 ? 'is-wrap' : '') + '">' + esc(text) + '</td>';
        }).join('') + '</tr>';
      }).join('');
      el('table').innerHTML = '<table class="hs-fit__table">' + head + body + '</table>';
    }

    function clearResult() {
      state.hit = -1;
      el('result').innerHTML = '';
      badge('');
      renderTable();
    }

    function badge(size) {
      var b = root.querySelector('[data-fit-badge]');
      if (b) b.textContent = size || '';
    }

    function verdict(index, why, extra) {
      state.hit = index;
      var size = data.rows[index][0];
      var input = sizeInput(size);
      var html = '<div class="hs-fit__result-size"><span>' + esc(data.sizeLabel) + '</span><b>' + esc(size) + '</b></div>';
      if (Array.isArray(why)) {
        html += '<ul class="hs-fit__why">' + why.map(function (line) {
          return '<li>' + esc(line) + '</li>';
        }).join('') + '</ul>';
      } else if (why) html += '<p>' + esc(why) + '</p>';
      if (data.standalone) {
        if (data.shopUrl) html += '<a class="button" href="' + esc(data.shopUrl) + '">' + esc(data.shopLabel || 'Shop') + '</a>';
      } else if (!input) html += '<p>This style is not made in ' + esc(size) + '.</p>';
      else if (input.dataset.optionAvailable === 'false') html += '<p>' + esc(size) + ' is sold out in the colour you picked. Try another colour.</p>';
      else html += '<button type="button" class="button" data-fit-select="' + esc(size) + '">' + esc(data.selectLabel) + ' · ' + esc(size) + '</button>';
      el('result').innerHTML = html + (extra || '');
      badge(data.standalone ? '' : size);
      renderTable();
    }

    function calcMeasure() {
      var picks = [];
      var out = false;
      measured.forEach(function (m) {
        var field = el('finder').querySelector('[data-fit-input="' + m.cell + '"]');
        var value = Number(field.value) * (state.unit === 'in' ? CM : 1);
        if (!value) return;
        var first = range(data.rows[0][m.cell]);
        var last = range(data.rows[data.rows.length - 1][m.cell]);
        if (!first || !last || value < first[0] - 4 || value > last[1] + 3) {
          out = true;
          return;
        }
        var index = data.rows.length - 1;
        for (var r = 0; r < data.rows.length; r++) {
          var rg = range(data.rows[r][m.cell]);
          if (rg && value <= rg[1]) {
            index = r;
            break;
          }
        }
        picks.push({ name: m.name, index: index });
      });

      if (out) {
        state.hit = -1;
        el('result').innerHTML = '<p>These measurements are outside this style\'s size range. Message us and we will suggest the closest style.</p>';
        return renderTable();
      }
      if (picks.length < Math.min(2, measured.length)) return clearResult();
      var top = picks.reduce(function (a, b) {
        return b.index > a.index ? b : a;
      });
      var same = picks.every(function (p) {
        return p.index === top.index;
      });
      var why = same
        ? 'All your measurements fall in ' + data.rows[top.index][0] + '.'
        : 'Your ' + top.name.toLowerCase() + ' measurement falls in ' + data.rows[top.index][0] + ', the larger of your sizes, so it sits comfortably.';
      verdict(top.index, why);
    }

    function calcBra() {
      var value = el('finder').querySelector('[data-fit-bra]').value;
      if (!value) return clearResult();
      verdict(Number(value), '');
    }

    // Where a measurement sits on the chart: 2.0 is the bottom of the third size, 2.5 its middle.
    // Gaps between two sizes are split in the middle.
    function position(cell, value) {
      var rs = data.rows.map(function (row) {
        return range(row[cell]);
      });
      if (rs.some(function (rg) { return !rg; })) return null;
      var n = rs.length;
      var lower = function (r) {
        return r === 0 ? rs[0][0] : (rs[r - 1][1] + rs[r][0]) / 2;
      };
      var upper = function (r) {
        return r === n - 1 ? rs[n - 1][1] : (rs[r][1] + rs[r + 1][0]) / 2;
      };
      if (value < lower(0)) return (value - lower(0)) / Math.max(upper(0) - lower(0), 1);
      for (var r = 0; r < n; r++) {
        if (value <= upper(r)) return r + (value - lower(r)) / Math.max(upper(r) - lower(r), 1);
      }
      return n + (value - upper(n - 1)) / Math.max(upper(n - 1) - lower(n - 1), 1);
    }

    function estimate(key) {
      var a = state.a;
      var spec = BODY[key];
      var bmi = a.w / Math.pow(a.h / 100, 2);
      return spec.slope * bmi + spec.base + spec.height * (a.h - 163) + a.shape[key] * SHAPE_CM;
    }

    function fmtLength(cm) {
      return state.a.sys === 'imperial' ? Math.round(cm / CM) + ' in' : Math.round(cm) + ' cm';
    }

    function fmtBody() {
      var a = state.a;
      if (a.sys === 'imperial') {
        var total = Math.round(a.h / CM);
        return Math.floor(total / 12) + ' ft ' + (total % 12) + ' in and ' + Math.round(a.w / KG) + ' lb';
      }
      return Math.round(a.h) + ' cm and ' + Math.round(a.w) + ' kg';
    }

    function listJoin(items) {
      return items.length < 2 ? items.join('') : items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
    }

    function calcQuiz() {
      var a = state.a;
      var picks = [];
      parts.forEach(function (p) {
        var value = estimate(p.key);
        var pos = position(p.cell, value);
        if (pos != null) picks.push({ part: p, value: value, pos: pos });
      });
      if (!picks.length) return clearResult();

      var top = picks.reduce(function (x, y) {
        return y.pos > x.pos ? y : x;
      });
      var last = data.rows.length - 1;
      var extra =
        '<p class="hs-fit__note">A recommendation from your answers, not a guarantee. For the closest match, <button type="button" class="hs-fit__link" data-fit-mode="tape">enter your measurements</button>.</p>';
      if (top.pos > last + 1.35) {
        state.hit = -1;
        el('result').innerHTML =
          '<p>From your answers, this style may run small for you. Message us and we will suggest the best size or style.</p>' + extra;
        badge('');
        return renderTable();
      }
      var pick = function (shift) {
        return Math.min(last, Math.max(0, Math.floor(top.pos + shift)));
      };
      var index = pick(FITS[a.fit].shift);
      var plain = pick(FITS.regular.shift);
      var size = data.rows[index][0];

      var shaped = parts.filter(function (p) {
        return a.shape[p.key];
      });
      var why = [
        'From ' + fmtBody() + (shaped.length ? ' with ' + listJoin(shaped.map(function (p) {
          return (p.key === 'hips' ? '' : 'a ') + (a.shape[p.key] > 0 ? 'fuller ' : 'narrower ') + BODY[p.key].label.toLowerCase();
        })) : '') + ', we estimate ' + listJoin(picks.map(function (p) {
          return 'your ' + p.part.name.toLowerCase() + ' at about ' + fmtLength(p.value);
        })) + '.'
      ];

      var spread = picks.some(function (p) {
        return Math.floor(p.pos + FITS.regular.shift) !== Math.floor(top.pos + FITS.regular.shift);
      });
      if (spread) why.push('We sized for your ' + top.part.name.toLowerCase() + ', the ' + (picks.length > 2 ? 'largest' : 'larger') + ' of your measurements, so nothing digs in.');

      if (a.fit === 'firm') {
        why.push(index < plain ? 'You like a firm hold, so we kept the snugger size.' : 'You like a firm hold, and ' + size + ' gives you the full shaping.');
      } else if (a.fit === 'comfort') {
        why.push(index > plain ? 'You prefer easy comfort, so we went one size up.' : 'You prefer easy comfort, and ' + size + ' already leaves room.');
      }

      verdict(index, why, extra);
    }

    function progress(step) {
      return (
        '<div class="hs-fit__progress"><span>Step ' + step + ' of 3</span>' +
        '<div class="hs-fit__bar"><i style="inline-size: ' + Math.round((step / 3) * 100) + '%"></i></div></div>'
      );
    }

    function stepNav(back, next, label, disabled) {
      return (
        '<div class="hs-fit__nav">' +
        (back ? '<button type="button" class="button button-secondary" data-fit-go="' + back + '">Back</button>' : '') +
        '<button type="button" class="button" data-fit-go="' + next + '"' + (disabled ? ' disabled' : '') + '>' + label + '</button>' +
        '</div>'
      );
    }

    function stepHead(title, sub) {
      return '<p class="hs-fit__q" tabindex="-1" data-fit-q-title>' + esc(title) + '</p>' + (sub ? '<p class="hs-fit__sub">' + esc(sub) + '</p>' : '');
    }

    function field(label, name, value, unit) {
      return (
        '<label class="hs-fit__field">' + esc(label) +
        '<span class="hs-fit__input"><input type="number" inputmode="decimal" min="0" step="1" data-fit-body="' + name + '" value="' + (value || '') + '">' +
        '<span>' + esc(unit) + '</span></span></label>'
      );
    }

    function renderQuiz() {
      var a = state.a;
      var html = '';
      if (state.step === 4) {
        var shaped = parts.filter(function (p) {
          return a.shape[p.key];
        }).map(function (p) {
          return (a.shape[p.key] > 0 ? 'Fuller ' : 'Narrower ') + BODY[p.key].label.toLowerCase();
        });
        var bits = [fmtBody().replace(' and ', ' · ')].concat(shaped, [FITS[a.fit].title]);
        el('finder').innerHTML =
          '<div class="hs-fit__summary"><span>' + esc(bits.join(' · ')) + '</span>' +
          '<button type="button" class="hs-fit__link" data-fit-go="1">Edit</button></div>';
        return calcQuiz();
      }

      html += progress(state.step);
      if (state.step === 1) {
        var imperial = a.sys === 'imperial';
        var total = Math.round(a.h / CM);
        html +=
          stepHead('Your height and weight', 'No tape measure needed.') +
          '<div class="hs-fit__units"><button type="button" data-fit-sys="metric" aria-pressed="' + !imperial + '">cm · kg</button>' +
          '<button type="button" data-fit-sys="imperial" aria-pressed="' + imperial + '">ft · lb</button></div>' +
          '<div class="hs-fit__fields">' +
          (imperial
            ? '<div class="hs-fit__pair">' + field('Height', 'ft', a.h ? Math.floor(total / 12) : '', 'ft') + field(' ', 'in', a.h ? total % 12 : '', 'in') + '</div>' +
              field('Weight', 'lb', a.w ? Math.round(a.w / KG) : '', 'lb')
            : field('Height', 'cm', a.h ? Math.round(a.h) : '', 'cm') + field('Weight', 'kg', a.w ? Math.round(a.w) : '', 'kg')) +
          '</div>' +
          stepNav(0, 2, 'Next', !validBody(a)) +
          '<button type="button" class="hs-fit__link hs-fit__switch" data-fit-mode="tape">I know my measurements</button>';
      } else if (state.step === 2) {
        html +=
          stepHead('Your shape', 'Compared with the rest of your body.') +
          '<div class="hs-fit__shapes">' +
          parts.map(function (p) {
            return (
              '<div class="hs-fit__shape" role="group" aria-label="' + esc(BODY[p.key].label) + '"><span>' + esc(BODY[p.key].label) + '</span>' +
              '<div class="hs-fit__seg">' +
              SHAPES.map(function (label, i) {
                return '<button type="button" data-fit-shape="' + p.key + '" data-value="' + (i - 1) + '" aria-pressed="' + (a.shape[p.key] === i - 1) + '">' + label + '</button>';
              }).join('') +
              '</div></div>'
            );
          }).join('') +
          '</div>' +
          stepNav(1, 3, 'Next');
      } else {
        html +=
          stepHead('How do you like it to fit?', '') +
          '<div class="hs-fit__prefs">' +
          Object.keys(FITS).map(function (key) {
            return (
              '<button type="button" class="hs-fit__pref" data-fit-pref="' + key + '" aria-pressed="' + (a.fit === key) + '">' +
              '<b>' + esc(FITS[key].title) + '</b><span>' + esc(FITS[key].text) + '</span></button>'
            );
          }).join('') +
          '</div>' +
          stepNav(2, 4, 'See my size');
      }
      el('finder').innerHTML = html;
    }

    function renderFinder() {
      if (data.kind === 'bra') {
        var options = '<option value="">Choose your bra size</option>';
        data.rows.forEach(function (row, r) {
          String(row[1] || '').split(',').forEach(function (bra) {
            if (bra.trim()) options += '<option value="' + r + '">' + esc(bra.trim()) + '</option>';
          });
        });
        el('finder').innerHTML = '<label class="hs-fit__field">Your usual bra size<select data-fit-bra>' + options + '</select></label>';
        return;
      }
      if (state.mode === 'quiz') return renderQuiz();
      el('finder').innerHTML =
        '<div class="hs-fit__units" data-fit-units><button type="button" data-unit="cm" aria-pressed="' + (state.unit === 'cm') + '">cm</button><button type="button" data-unit="in" aria-pressed="' + (state.unit === 'in') + '">inches</button></div>' +
        '<div class="hs-fit__fields">' +
        measured.map(function (m) {
          return '<label class="hs-fit__field">' + esc(m.name) + '<input type="number" inputmode="decimal" min="0" step="0.5" data-fit-input="' + m.cell + '"></label>';
        }).join('') +
        '</div>' +
        (canQuiz ? '<button type="button" class="hs-fit__link hs-fit__switch" data-fit-mode="quiz">No tape measure? Use your height and weight</button>' : '');
    }

    function go(step, focus) {
      state.step = step;
      if (step === 4) {
        state.a.done = true;
        saveAnswers(state.a);
      } else {
        clearResult();
      }
      renderFinder();
      if (focus) {
        var title = el('q-title') || el('finder').querySelector('button');
        if (title) title.focus({ preventScroll: true });
      }
    }

    function readBody() {
      var get = function (name) {
        var input = el('finder').querySelector('[data-fit-body="' + name + '"]');
        return input ? Number(input.value) || 0 : 0;
      };
      if (state.a.sys === 'imperial') {
        var ft = get('ft');
        state.a.h = ft || get('in') ? (ft * 12 + get('in')) * CM : 0;
        state.a.w = get('lb') * KG;
      } else {
        state.a.h = get('cm');
        state.a.w = get('kg');
      }
      var next = el('finder').querySelector('[data-fit-go="2"]');
      if (next) next.disabled = !validBody(state.a);
    }

    root.addEventListener('click', function (event) {
      var open = event.target.closest('[data-fit-open]');
      if (open) return show(open.dataset.fitOpen);

      var tab = event.target.closest('[data-fit-tab]');
      if (tab) return show(tab.dataset.fitTab);

      var unit = event.target.closest('[data-unit]');
      if (unit && unit.dataset.unit !== state.unit) {
        var factor = unit.dataset.unit === 'in' ? 1 / CM : CM;
        el('finder').querySelectorAll('[data-fit-input]').forEach(function (field) {
          if (Number(field.value)) field.value = Math.round(Number(field.value) * factor * 2) / 2;
        });
        state.unit = unit.dataset.unit;
        el('finder').querySelectorAll('[data-unit]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === unit));
        });
        return calcMeasure();
      }

      var mode = event.target.closest('[data-fit-mode]');
      if (mode) {
        state.mode = mode.dataset.fitMode;
        state.unit = 'cm';
        return later(function () {
          if (state.mode === 'quiz') return go(state.a.done && validBody(state.a) ? 4 : 1, true);
          clearResult();
          renderFinder();
          var first = el('finder').querySelector('input');
          if (first) first.focus({ preventScroll: true });
        });
      }

      var sys = event.target.closest('[data-fit-sys]');
      if (sys && sys.dataset.fitSys !== state.a.sys) {
        state.a.sys = sys.dataset.fitSys;
        return later(function () {
          renderFinder();
          var pressed = el('finder').querySelector('[data-fit-sys="' + state.a.sys + '"]');
          if (pressed) pressed.focus({ preventScroll: true });
        });
      }

      var goTo = event.target.closest('[data-fit-go]');
      if (goTo && !goTo.disabled) {
        return later(function () {
          go(Number(goTo.dataset.fitGo), true);
        });
      }

      var shape = event.target.closest('[data-fit-shape]');
      if (shape) {
        state.a.shape[shape.dataset.fitShape] = Number(shape.dataset.value);
        shape.parentNode.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === shape));
        });
        return;
      }

      var pref = event.target.closest('[data-fit-pref]');
      if (pref) {
        state.a.fit = pref.dataset.fitPref;
        pref.parentNode.querySelectorAll('[data-fit-pref]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === pref));
        });
        return;
      }

      var select = event.target.closest('[data-fit-select]');
      if (select) {
        var input = sizeInput(select.dataset.fitSelect);
        if (input) input.click();
        if (typeof root.closeDialog === 'function') root.closeDialog();
      }
    });
    root.addEventListener('input', function (event) {
      if (!event.target.closest('[data-fit-finder]')) return;
      if (event.target.closest('[data-fit-body]')) return readBody();
      if (data.kind === 'bra') calcBra();
      else calcMeasure();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.closest('[data-fit-body]')) return;
      event.preventDefault();
      readBody();
      if (validBody(state.a)) go(2, true);
    });

    root.__hsFit = function () {
      state.hit = -1;
      state.unit = 'cm';
      state.mode = canQuiz ? 'quiz' : 'tape';
      state.step = state.a.done && validBody(state.a) ? 4 : 1;
      el('result').innerHTML = '';
      badge('');
      renderFinder();
      renderTable();
    };
    root.__hsFit();
  }

  function init() {
    document.querySelectorAll('[data-hs-fit]').forEach(setup);
  }

  // Category tabs on the size guide page; #bra style links open a tab directly
  function showTab(group, name) {
    if (!group.querySelector('[data-hs-tabpanel="' + name + '"]')) return;
    group.querySelectorAll('[data-hs-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', String(b.dataset.hsTab === name));
    });
    group.querySelectorAll('[data-hs-tabpanel]').forEach(function (panel) {
      panel.hidden = panel.dataset.hsTabpanel !== name;
    });
  }
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-hs-tab]');
    if (!tab) return;
    showTab(tab.closest('[data-hs-tabs]'), tab.dataset.hsTab);
    history.replaceState(null, '', '#' + tab.dataset.hsTab);
  });
  function openFromHash() {
    var name = decodeURIComponent(location.hash.slice(1));
    if (name && /^[a-z0-9-]+$/.test(name)) document.querySelectorAll('[data-hs-tabs]').forEach(function (group) { showTab(group, name); });
  }
  window.addEventListener('hashchange', openFromHash);
  openFromHash();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Horizon re-renders product blocks when the variant changes
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      init();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
